import React from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@material-ui/core/index'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'
import { orderExtend, orderExtendInfo } from '../../../../helpers/restHelpers'
import Alert from '@material-ui/lab/Alert'

const initialState = {
    open: false,
    loading: false,
    extendInfo: null,
    openResult: false,
    result: null,
}

class Component extends React.Component {
    state = { ...initialState }

    handleClickOpen = () => {
        this.setState({ ...initialState, open: true, loading: true })

        orderExtendInfo(this.props.orderId)
            .then((x) => this.setState({ loading: false, extendInfo: x }))
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ ...initialState })
    }

    confirm = () => {
        this.setState({ loading: true, open: false })
        orderExtend(this.props.orderId)
            .then((x) =>
                this.setState({ loading: false, openResult: true, result: x })
            )
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    render() {
        const { extendInfo, result } = this.state
        const styles = {
            hr: { width: '100%' },
            content: {
                display: 'flex',
                flexWrap: 'wrap',
                padding: 20,
                margin: 'auto',
            },
            label: { width: '40%', minWidth: 200 },
            infoText: { backgroundColor: '' },
        }
        return (
            <div style={{ width: '100%' }}>
                <div onClick={this.handleClickOpen}>
                    {strings.orderExtendButton}
                </div>
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {strings.orderExtendDialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        {!extendInfo ? null : (
                            <div style={styles.content}>
                                <div style={styles.label}>
                                    {strings.orderExtendDialog_currentDate}
                                </div>
                                <div>{extendInfo.currentDate}</div>
                                <hr style={styles.hr} />
                                <div style={styles.label}>
                                    {strings.orderExtendDialog_lastValidDate}
                                </div>
                                <div>{extendInfo.lastValidDate}</div>
                                <hr style={styles.hr} />
                                <div style={styles.label}>
                                    {strings.orderExtendDialog_validTo}
                                </div>
                                <div>{extendInfo.validTo}</div>
                                <hr style={styles.hr} />
                                <div style={styles.label}>
                                    {strings.orderExtendDialog_periodToExtend}
                                </div>
                                <div>
                                    {extendInfo.periodToExtendinDaysAndMinutes}
                                </div>
                                <hr style={styles.hr} />
                                <div style={styles.label}>
                                    {strings.orderExtendDialog_amount}
                                </div>
                                <div>{extendInfo.amount}</div>
                                <hr style={styles.hr} />

                                <Alert severity="error">
                                    {strings.orderExtendDialogText}
                                </Alert>
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleClose}
                            color="primary"
                            disabled={this.state.loading}
                        >
                            {strings.close}
                        </Button>
                        <Button
                            onClick={this.confirm}
                            color="primary"
                            autoFocus
                            disabled={this.state.loading}
                        >
                            {strings.continue}
                        </Button>
                    </DialogActions>
                    {this.state.loading ? <Loader /> : null}
                </Dialog>

                <Dialog
                    open={this.state.openResult}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {strings.orderExtendSuccessTitle}
                    </DialogTitle>
                    <DialogContent>
                        {!result ? null : (
                            <div style={styles.content}>
                                <div style={styles.label}>
                                    {strings.orderExtendDialog_referenceId}
                                </div>
                                <div>{result.referenceId}</div>
                                <hr style={styles.hr} />
                                <div style={styles.label}>
                                    {strings.orderExtendDialog_expirationDate}
                                </div>
                                <div>{result.expirationDate}</div>
                                <hr style={styles.hr} />
                                <div style={styles.label}>
                                    {strings.orderExtendDialog_daysExtended}
                                </div>
                                <div>{result.daysExtended}</div>
                                <hr style={styles.hr} />
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => this.setState({ openResult: false })}
                            color="primary"
                            disabled={this.state.loading}
                        >
                            {strings.close}
                        </Button>
                    </DialogActions>
                    {this.state.loading ? <Loader /> : null}
                </Dialog>
            </div>
        )
    }
}

export default Component
